import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { elementGroups } from '../data/periodicTableData';
import ElementCard from '../components/ElementCard';
import GroupNavigation from '../components/GroupNavigation';
const GroupPage: React.FC = () => {
  const {
    groupId
  } = useParams<{
    groupId: string;
  }>();
  // Handle invalid group ID
  if (!groupId || !elementGroups[groupId]) {
    return <Navigate to="/" replace data-id="element-56" />;
  }
  const group = elementGroups[groupId];
  return <div className="space-y-6" data-id="element-57">
      <GroupNavigation data-id="element-58" />
      <div className="bg-white rounded-lg shadow-md p-6" data-id="element-59">
        <h2 className="text-2xl font-semibold mb-2" data-id="element-60">{group.name}</h2>
        <p className="text-gray-600 mb-6" data-id="element-61">{group.description}</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" data-id="element-62">
          {group.elements.map(element => <ElementCard key={element.atomicNumber} element={element} data-id="element-63" />)}
        </div>
      </div>
    </div>;
};
export default GroupPage;